import {
  useCallback,
  useEffect,
  useRef,
  useState
} from "react";
import { FormHandles } from "@unform/core";
import {
  faDownload,
  faX
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Panel from "../../../../components/Panel";
import {
  ButtonDownloadArch,
  ContainerButton2,
  Form,
  Input,
  TextTitle,
  Textarea,
  Title
} from '../../../../styles/global';
import Radio from "../../../../components/InputRadio";
import SecondaryTable from "../../../../components/SecondaryTable";
import { GridColDef, GridRenderEditCellParams, GridValueFormatterParams, GridValueSetterParams, useGridApiRef } from "@mui/x-data-grid";
import { Button, Container } from "@mui/material";
import useAteste from "../../../../actions/cruds/Financeiro/useAteste";
import { Link, useParams } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2";
import { SaveWithProgress } from "../../../../components/SaveCircularIntegration";
import { formatCPF, formatarData, formatarReais, formatarRealparaDecimal } from "../../../../utils/formatDados";
import { SubTitle } from "../styles";
import useContaBancaria from "../../../../actions/cruds/Financeiro/useContaBancaria";
import organizeDataSelect from "../../../../utils/organizeDataSelect";
import useInstrumento from "../../../../actions/cruds/InstrumentoContratual/useInstrumento";
import useAutorizacaoDespesa from "../../../../actions/cruds/Financeiro/useAutorizacaoDespesa";
import InputNumberFormat from "../../../../components/InputNumberFormat";
import useProcesso from "../../../../actions/cruds/Processos/useProcesso";
import { useToast } from "../../../../hooks/toast";

const FinanceiroRealizarPagamentoDespesa: React.FC = () => {
  const { autorizacaoDespesaId } = useParams();
  const { autorizacaoDespesa, getAutorizacaoDespesa, updateAutorizacaoDespesa } = useAutorizacaoDespesa();
  const { ateste, getAteste } = useAteste();
  const { instrumento, getInstrumento } = useInstrumento();
  const { processo, getProcesso } = useProcesso();
  const { contasBancarias, getContasBancarias } = useContaBancaria();
  const { addToast } = useToast();

  const [contasBancariasOptions, setContasBancariasOptions] = useState([]);
  const [contaBancariaId, setContaBancariaId] = useState<number>();
  const [valorImposto, setValorImposto] = useState<number>(0);
  const [valorLiquido, setValorLiquido] = useState<number>();
  const [salvando, setSalvando] = useState<boolean>(false);

  useEffect(() => {
    getAutorizacaoDespesa(autorizacaoDespesaId);
    getContasBancarias([{ label: "ativo", value: true }, { label: "per", value: 200 }]);
  }, [])

  useEffect(() => {
    if (autorizacaoDespesa?.id) {
      getAteste(autorizacaoDespesa?.attest?.id);
    };
  }, [autorizacaoDespesa])

  useEffect(() => {
    if (ateste.id) {
      formRef.current?.setFieldValue("tipo_pagamento", ateste.tipo_pagamento);
      getInstrumento(ateste?.contractual_instrument?.id);
    };

  }, [ateste]);


  useEffect(() => {
    if (instrumento?.id) {
      if (instrumento?.law_process?.id) {
        getProcesso(instrumento?.law_process?.id);
      }
    };

  }, [instrumento]);

  useEffect(() => {
    if (contasBancarias) {
      setContasBancariasOptions(organizeDataContaBancaria(contasBancarias.data));
    };

  }, [contasBancarias])

  const organizeDataContaBancaria = (data) => {
    if (typeof data === 'object') {
      if (Object.keys(data).length > 0) {
        data = data.map(d => ({
          value: d.id,
          label: `${d.apelido} - Conta ${d.conta_tipo}, Ag: ${d.conta_agencia} CC: ${d.conta_numero}`
        }));
        return data;
      }
    }
    return [];
  };


  const organizeDataLinhas = (data) => {
    if (typeof data === 'object') {
      if (Object.keys(data).length > 0) {
        data = data.map(d => ({
          id: d.id,
          contractual_instrument_budget_id: d?.contractual_instrument_budget?.id,
          contrato: d?.contractual_instrument_budget?.project_line?.management_contract?.nome_completo,
          comite: d?.contractual_instrument_budget?.project_line?.comittee?.nome,
          codigo_contabil: `${d?.contractual_instrument_budget?.project_line?.expense_type?.codigo}.${d?.contractual_instrument_budget?.project_line?.organization?.codigo.padStart(2, '0')}.${d?.contractual_instrument_budget?.project_line?.management_contract?.codigo.padStart(2, '0')}.${d?.contractual_instrument_budget?.project_line?.comittee?.codigo.padStart(2, '0')}.${d?.contractual_instrument_budget?.project_line?.unit?.codigo.padStart(2, '0')}.${d?.contractual_instrument_budget?.project_line?.pap_finality?.codigo.padStart(2, '0')}.${d?.contractual_instrument_budget?.project_line?.pap_program?.codigo.padStart(2, '0')}.${d?.contractual_instrument_budget?.project_line?.pap_action?.codigo.padStart(2, '0')}.${d?.contractual_instrument_budget?.project_line?.poa_sub_action?.codigo.padStart(2, '0')}.${processo?.project?.id?.toString().padStart(2, '0')}.${d?.contractual_instrument_budget?.project_line?.description?.codigo.padStart(3, '0')}`,
          valor_rubrica: formatarReais(d?.valor),
          percentual: `${d?.percentual}%`,
          conta: "Selecione uma conta >",
        }));
        return data;
      }
    }
    return [];
  };

  const organizeDataNotaFiscal = (data) => {
    if (typeof data === 'object') {
      if (Object.keys(data).length > 0) {
        data = data.map(d => ({
          id: d.id,
          contrato: d.management_contract.nome_completo,
          documento_fiscal: d.documento_fiscal,
          valor: formatarReais(d.valor),
          tipo_documento: d.tipo,
          dataDocumento: formatarData(d.data, false),
          url_arquivo: `${d.url_arquivo}/${d.nome_arquivo}`,
          attest_budgets: d.attest_budgets,
        }));

        data.forEach((data) => {
          let codigo = [];
          let linhasConcatenadas;

          data.attest_budgets?.forEach((inv, index) => {
            codigo.push(organizeDataAttestBudget(inv))
            linhasConcatenadas = codigo.map(objeto => objeto.linha).join('\n');
          });

          data.linhas = linhasConcatenadas;
        });

        return data;
      }
    }
    return [];
  };

  const organizeDataAttestBudget = (data) => {
    if (typeof data === 'object') {
      if (Object.keys(data).length > 0) {
        return {
          linha: `${data?.contractual_instrument_budget?.project_line?.expense_type?.codigo}.${data?.contractual_instrument_budget?.project_line?.organization?.codigo.padStart(2, '0')}.${data?.contractual_instrument_budget?.project_line?.management_contract?.codigo.padStart(2, '0')}.${data?.contractual_instrument_budget?.project_line?.comittee?.codigo.padStart(2, '0')}.${data?.contractual_instrument_budget?.project_line?.unit?.codigo.padStart(2, '0')}.${data?.contractual_instrument_budget?.project_line?.pap_finality?.codigo.padStart(2, '0')}.${data?.contractual_instrument_budget?.project_line?.pap_program?.codigo.padStart(2, '0')}.${data?.contractual_instrument_budget?.project_line?.pap_action?.codigo.padStart(2, '0')}.${data?.contractual_instrument_budget?.project_line?.poa_sub_action?.codigo.padStart(2, '0')}.${processo?.project?.id?.toString().padStart(2, '0')}.${data?.contractual_instrument_budget?.project_line?.description?.codigo.padStart(3, '0')}`,
        };
      }
    }
    return [];
  };

  const apiRef = useGridApiRef();
  const formRef = useRef<FormHandles>(null);

  const handleSubmit = useCallback(
    async (data: object) => {
      try {
        setSalvando(true);

        const rowsData = Array.from(apiRef.current.getRowModels(), ([, value]) => (value));
        const rubricaSemValor = rowsData.every(row => row.valor);
        const rubricaSemConta = rowsData.find((row) => row.conta == 'Selecione uma conta >');

        if (!rubricaSemValor) {
          addToast({
            type: 'error',
            title: 'Erro',
            description: "Todas as linhas da Rubrica orçamentária devem conter valor.",
          });
          return;
        };
        if (rubricaSemConta) {
          addToast({
            type: 'error',
            title: 'Erro',
            description: "Todas as linhas da Rubrica orçamentária devem conter conta.",
          });
          return;
        };

        data["pis"] = formatarRealparaDecimal(data.pis);
        data["cofins"] = formatarRealparaDecimal(data.cofins);
        data["iss"] = formatarRealparaDecimal(data.iss);
        data["ir"] = formatarRealparaDecimal(data.ir);
        data["inss"] = formatarRealparaDecimal(data.inss);
        data["situacao"] = "aguardando_confirmacao_pagamento";


        data["expense_authorization_budgets_attributes"] = rowsData.map(d => ({
          attest_budget_id: d.id,
          bank_account_id: d.conta,
          valor: d.valor,
        }));

        console.log('data: ', data);
        await updateAutorizacaoDespesa(autorizacaoDespesaId, data);
      } catch (err) {

      } finally {
        setSalvando(false);
      }
    },
    [],
  );

  const tipoPagamentoOptions = [
    { id: "Depósito", value: "Depósito", label: "Depósito" },
    { id: "Boleto/Fatura", value: "Boleto/Fatura", label: "Boleto/Fatura" }
  ];

  const dataTitleRubrica: GridColDef[] = [
    { field: "contrato", headerName: "Contrato de gestão", flex: 2 },
    { field: "comite", headerName: "Comitê", flex: 2 },
    { field: "codigo_contabil", headerName: "Código Contábil", flex: 3 },
    { field: "valor_rubrica", headerName: "Valor", flex: 1 },
    { field: "percentual", headerName: "Percentual", flex: 1 },
  ];

  const dataTitleNotaFiscal: GridColDef[] = [
    { field: "contrato", headerName: "Contrato de Gestão", flex: 2 },
    { field: "linhas", headerName: "Linhas", flex: 2 },
    { field: "dataDocumento", headerName: "Data", flex: 1 },
    { field: "tipo_documento", headerName: "Tipo", flex: 1 },
    { field: "documento_fiscal", headerName: "Documento Fiscal", flex: 1 },
    { field: "valor", headerName: "Valor", flex: 1 },
    {
      field: "action",
      headerName: "Documento",
      sortable: false,
      flex: 1,
      renderCell: (params) => {
        return (
          <Link to={{ pathname: params.row.url_arquivo }} target="_blank">
            <Button variant="text">
              <FontAwesomeIcon icon="fa-solid fa-file-arrow-down" />
            </Button>
          </Link>
        );
      }
    }
  ];

  const dataTitleContaContabil: GridColDef[] = [
    { field: "contrato", headerName: "Contrato de gestão", flex: 2 },
    { field: "comite", headerName: "Comitê", flex: 2 },
    { field: "codigo_contabil", headerName: "Código Contábil", flex: 3 },
    {
      field: "valor",
      headerName: "Valor",
      editable: true,
      flex: 2,
      valueFormatter: (params: GridValueFormatterParams<number>) => {
        if (params.value == null) {
          return "R$ 0,00";
        }
        return params.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
      },
      renderEditCell: (params: GridRenderEditCellParams) => (
        <InputNumberFormat {...params} />
      ),
    },
    {
      field: "conta",
      headerName: "Conta bancária",
      editable: true,
      type: "singleSelect",
      valueOptions: contasBancariasOptions,
      flex: 2,
      valueFormatter: (params: GridValueFormatterParams<any>) => {
        if (params.value == null) {
          return "Selecione uma conta >";
        } else if (params.value) {
          return contasBancariasOptions.find((conta) => conta.value == params.value)?.label
        }
      },
    }
  ];

  const handleChangeImposto = () => {
    const pis = formatarRealparaDecimal(formRef.current?.getFieldValue("pis"));
    const cofins = formatarRealparaDecimal(formRef.current?.getFieldValue("cofins"));
    const iss = formatarRealparaDecimal(formRef.current?.getFieldValue("iss"));
    const ir = formatarRealparaDecimal(formRef.current?.getFieldValue("ir"));
    const inss = formatarRealparaDecimal(formRef.current?.getFieldValue("inss"));
    
    const toFloat = (value) => isNaN(parseFloat(value)) ? 0 : parseFloat(value);
    const somaImposto = toFloat(pis) + toFloat(cofins) + toFloat(iss) + toFloat(ir) + toFloat(inss);

    setValorLiquido(toFloat(autorizacaoDespesa?.invoice?.valor) - somaImposto);
    setValorImposto(somaImposto);
  };

  const checkKeyDown = (e) => {
    if (e.key === 'Enter') e.preventDefault();
  };

  return (
    <Container>
      <Form id="formAutorizacao" ref={formRef} onSubmit={handleSubmit} onKeyDown={(e) => checkKeyDown(e)}>
        <Title color='#333'>
          <span>Realizar Pagamento de Despesa</span>
        </Title>

        <Panel titulo="Identificação">
          <Grid container spacing={6}>
            <Grid xs={6}>
              <TextTitle>Número do Instrumento:</TextTitle>
              <Input name="numeroContrato" type="text" value={ateste.contractual_instrument?.numero} disabled />
            </Grid>
            <Grid xs={6}>
              <TextTitle>Número do Processo: <span>*</span></TextTitle>
              <Input
                type="text"
                name="numeroProcesso"
                value={instrumento?.law_process?.id ? `${instrumento.law_process?.codigo} - SIGAD (${instrumento.law_process?.numero})` : ""}
                disabled
              />
            </Grid>
            <Grid xs={6}>
              <TextTitle>Modalidade da contratação: <span>*</span></TextTitle>
              <Input name="modalidadeContratacao" type="text" value={ateste.contractual_instrument?.tipo_instrumento} disabled />
            </Grid>
            <Grid xs={12}>
              <SubTitle>Ordenadores de Despesa: (NI nº 1620/2021) </SubTitle>
            </Grid>
            <Grid xs={6}>
              <TextTitle>Ordenador 01: <span>*</span></TextTitle>
              <Input
                type="text"
                name="ordenador1"
                value={ateste.ordenador1?.nome}
                disabled
              />
            </Grid>
            <Grid xs={6}>
              <TextTitle>Ordenador 02: <span>*</span></TextTitle>
              <Input
                type="text"
                name="ordenador2"
                value={ateste.ordenador2?.nome}
                disabled
              />
            </Grid>
          </Grid>
        </Panel>

        <Panel titulo="Dados do contrato">
          <Grid container spacing={6}>
            <Grid xs={6}>
              <TextTitle>Data de início do contrato:</TextTitle>
              <Input type="date" name="dataInicio" value={instrumento?.data_inicio_vigencia} disabled />
            </Grid>
            <Grid xs={6}>
              <TextTitle>Data de término do contrato:</TextTitle>
              <Input type="date" name="dataTermino" value={instrumento?.data_termino_vigencia} disabled />
            </Grid>
            <Grid xs={4}>
              <TextTitle>Valor do contrato:</TextTitle>
              <Input type="text" name="valorTotal" value={formatarReais(instrumento?.valor_total)} disabled />
            </Grid>
            <Grid xs={4}>
              <TextTitle>Desembolso:</TextTitle>
              <Input type="text" name="desembolso" disabled />
            </Grid>
            <Grid xs={4}>
              <TextTitle>Saldo do contrato:</TextTitle>
              <Input type="text" name="saldoContrato" disabled />
            </Grid>
          </Grid>
        </Panel>

        <Panel titulo="Dados da Empresa">
          <Grid container spacing={6}>
            <Grid xs={12}>
              <TextTitle>Empresa: <span>*</span></TextTitle>
              <Input
                type="text"
                id="supplier"
                name="supplier"
                value={ateste.supplier?.nome_razao_social}
                disabled
              />
            </Grid>
            <Grid xs={6}>
              <TextTitle>CPF/CNPJ:</TextTitle>
              <Input name="supplierCpfCnpj" type="text" value={ateste.supplier?.cpf_cnpj} disabled />
            </Grid>
            <Grid xs={6}>
              <TextTitle>Pagamento: <span>*</span></TextTitle>
              <Radio
                name="tipoPagamento"
                options={tipoPagamentoOptions}
                disabled
              />
            </Grid>
            {ateste.tipo_pagamento == 'Boleto/Fatura' ? (
              <>
                <Grid xs={6}>
                  <TextTitle>Código do boleto: </TextTitle>
                  <Input name="codigoBoleto" type="text" value={ateste.codigo_boleto} disabled />
                </Grid>
                <Grid xs={6}>
                  <TextTitle>Data de vencimento:</TextTitle>
                  <Input name="dataVencimento" type="date" value={ateste.data_vencimento} disabled />
                </Grid>
              </>
            ) : (
              <>
                <Grid xs={12}>
                  {ateste?.contractual_instrument?.tipo_instrumento == 'Convênios' ? (
                    <TextTitle>Conta bancária da empresa (convênio): </TextTitle>
                  )
                    : (
                      <TextTitle>Conta bancária da empresa: </TextTitle>
                    )}
                </Grid>
                <Grid xs={6} lg={3}>
                  <TextTitle>Tipo de conta:</TextTitle>
                  <Input
                    type="text"
                    id="tipoConta"
                    name="bancoIipoConta"
                    value={ateste.banco_tipo_conta}
                    disabled
                  />
                </Grid>
                <Grid xs={6} lg={3}>
                  <TextTitle>Banco:</TextTitle>
                  <Input
                    type="text"
                    id="banco"
                    name="bancoNome"
                    value={ateste.banco_nome}
                    disabled
                  />
                </Grid>
                <Grid xs={6} lg={3}>
                  <TextTitle>Agência:</TextTitle>
                  <Input name="bancoAgencia" type="text" value={ateste.banco_agencia} disabled />
                </Grid>
                <Grid xs={6} lg={3}>
                  <TextTitle>Conta:</TextTitle>
                  <Input name="bancoConta" type="text" value={ateste.banco_conta} disabled />
                </Grid>
              </>
            )}
          </Grid>
        </Panel>

        <Panel titulo="Objeto do pagamento">
          <Grid container spacing={6}>
            <Grid xs={12}>
              <TextTitle>Descrição:</TextTitle>
              <Textarea name="objetoPagamento" defaultValue={ateste.objeto_pagamento} disabled />
            </Grid>
            <Grid xs={12}>
              <TextTitle>Medição:</TextTitle>
              <Textarea name="medicao1" value={ateste.medicao} disabled />
            </Grid>
            <Grid xs={6}>
              <TextTitle>Número da nota Técnica:</TextTitle>
              <Input name="numeroNotaTecnica" type="text" value={ateste.numero_nota_tecnica} disabled />
            </Grid>
            <Grid xs={6}>
              <TextTitle>Nota Técnica:</TextTitle>
              <Link
                to={{
                  pathname: `${ateste?.url_arquivo}/${ateste?.nome_arquivo}`,
                }}
                target="_blank"
              >
                <ButtonDownloadArch name='selecionararquivo' type="button">
                  <FontAwesomeIcon icon={faDownload} size="1x" /> Download...
                </ButtonDownloadArch>
              </Link>
            </Grid>
          </Grid>
        </Panel>

        <Panel titulo="Rubrica orçamentária">
          <Grid container spacing={6}>
            <Grid xs={6}>
              <TextTitle>Valor total do ateste:</TextTitle>
              <span>R${ateste.valor_total}</span>
            </Grid>
            <Grid xs={12}>
              {ateste.attest_budgets?.length > 0 && processo?.id && (
                <SecondaryTable
                  columsData={dataTitleRubrica}
                  rowsData={organizeDataLinhas(ateste?.attest_budgets)}
                />
              )}
            </Grid>
          </Grid>
        </Panel>

        <Panel titulo="Nota Fiscal">
          <Grid container spacing={6}>
            {ateste.invoices?.length > 0 && processo?.id && (
              <>
                <Grid xs={12}>
                  <SecondaryTable
                    columsData={dataTitleNotaFiscal}
                    rowsData={organizeDataNotaFiscal(ateste?.invoices)}
                  />
                </Grid>
                <Grid xs={6}>
                  <TextTitle>Total: {formatarReais(ateste?.invoices?.reduce(function (acc, obj) { return acc + parseFloat(obj?.valor); }, 0))}</TextTitle>
                </Grid>
              </>
            )}
          </Grid>
        </Panel>

        <Panel titulo="Retenções">
          <Grid container spacing={6}>
            <Grid xs={6} lg={4}>
              <TextTitle>Contrato de gestão:</TextTitle>
              <Input type="text" id="contratoGestao" name="contratoGestao" value={autorizacaoDespesa?.invoice?.management_contract?.nome_completo} disabled />
            </Grid>
            <Grid xs={6} lg={4}>
              <TextTitle>Nota fiscal:</TextTitle>
              <Input type="text" id="notafiscal" name="notafiscal" value={autorizacaoDespesa?.invoice?.documento_fiscal} disabled />
            </Grid>
            <Grid xs={6} lg={4}>
              <TextTitle>Valor da nota:</TextTitle>
              <Input type="text" id="tipoConta" name="banco_tipo_conta" value={formatarReais(autorizacaoDespesa?.invoice?.valor)} disabled />
            </Grid>
            <Grid xs={6} lg={2.4}>
              <TextTitle>PIS:</TextTitle>
              <Input id="pis" name="pis" format="currency" currency="BRL" onChange={handleChangeImposto} required />
            </Grid>
            <Grid xs={6} lg={2.4}>
              <TextTitle>COFINS:</TextTitle>
              <Input id="cofins" name="cofins" format="currency" currency="BRL" onChange={handleChangeImposto} required />
            </Grid>
            <Grid xs={6} lg={2.4}>
              <TextTitle>ISS:</TextTitle>
              <Input name="iss" format="currency" currency="BRL" onChange={handleChangeImposto} required />
            </Grid>
            <Grid xs={6} lg={2.4}>
              <TextTitle>IR:</TextTitle>
              <Input name="ir" format="currency" currency="BRL" onChange={handleChangeImposto} required />
            </Grid>
            <Grid xs={6} lg={2.4}>
              <TextTitle>INSS:</TextTitle>
              <Input name="inss" format="currency" currency="BRL" onChange={handleChangeImposto} required />
            </Grid>
            <Grid xs={6}>
              <TextTitle>Valor total de impostos:</TextTitle>
              <Input type="text" id="valorTotalImposto" name="valorTotalImposto" value={formatarReais(valorImposto)} disabled />
            </Grid>
            <Grid xs={6}>
              <TextTitle>Valor líquido da nota:</TextTitle>
              <Input type="text" id="valorLiquidoNota" name="valorLiquidoNota" value={formatarReais(valorLiquido)} disabled />
            </Grid>
          </Grid>
        </Panel>

        <Panel titulo="Conta contábil">
          <Grid container spacing={6}>
            <Grid xs={12}>
              {autorizacaoDespesa?.invoice?.attest_budgets?.length > 0 && processo?.id && (
                <SecondaryTable
                  apiRef={apiRef}
                  columsData={dataTitleContaContabil}
                  rowsData={organizeDataLinhas(autorizacaoDespesa?.invoice?.attest_budgets)}
                />
              )}
            </Grid>
          </Grid>
        </Panel>
      </Form>

      <ContainerButton2>
        <Link to="/financeiro/autorizacaodespesa">
          <button className="button_return">
            <FontAwesomeIcon icon={faX} size="1x" /> Cancelar
          </button>
        </Link>
        <SaveWithProgress disabled={salvando} form={"formAutorizacao"}></SaveWithProgress>
      </ContainerButton2>
    </Container>
  );
};

export default FinanceiroRealizarPagamentoDespesa;